module.exports = __webpack_public_path__ + "static/media/timer.8a341d88.svg";